<template>
  <div class="">
    <div class="product-card-keyword-1-wrapper" v-if="showKeywords">
      <span class="badge product-card-keyword-1 m-1" v-for="item in product.keywords">{{ item.keyword }}</span>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {productCardKeywords} from "./ProductCardKeywords";

export default defineComponent({
  name: "ProductCardKeywords1",
  props: {
    product: {},
    ...productCardKeywords
  }
})
</script>

<style scoped>

</style>